import { resourcePath } from '@gameday/utils/resource-path';
import { getSafeLanguagePath } from './languageHelpers';
export default ({ nameSlug = '', language = 'en', playerPageContext = 'mlb' }) => {
    const playerParams = {
        pid: nameSlug,
        languagePath: getSafeLanguagePath(language)
    };

    return resourcePath.get(`${playerPageContext}PlayerPage`, playerParams) || resourcePath.get('playerPage', playerParams);
};
